import type { NavigateFunction } from "react-router-dom";

export const setConversationUrl = (
  navigate: NavigateFunction,
  conversationId: string,
  exchangeId?: string,
) => {
  const params = new URLSearchParams({ conversation: conversationId });
  if (exchangeId) {
    params.set("exchange", exchangeId);
  }
  navigate(`/?${params.toString()}`);
};

export const clearConversationUrl = (navigate: NavigateFunction) => {
  navigate("/");
};
